import { zodResolver } from "@hookform/resolvers/zod";
import { Dispatch, SetStateAction, useMemo, useState } from "react";
import { Control, useForm, UseFormHandleSubmit, UseFormReturn } from "react-hook-form";
import { any, object, record } from "zod";

import { useT } from "src/internationalization";
import { SecondaryCriteria } from "src/pages/Rules/linkedCase/SecondaryCriteria";
import { ClientSchemaIdentifier } from "src/types/clientSchema";

export type IdentifierFormControl = {
  control: Control<IdentifierFormData>;
  submit: UseFormHandleSubmit<IdentifierFormData>;
  reset: () => void;
  hasError: boolean;
  secondaryCriteriaList: SecondaryCriteria[];
  setSecondaryCriteriaList: Dispatch<SetStateAction<SecondaryCriteria[]>>;
  methods: UseFormReturn<IdentifierFormData>;
};

type IdentifierFormData = {
  identifier: ClientSchemaIdentifier | null;
};

export type ValidatedIdentifierFormData = {
  identifier: ClientSchemaIdentifier;
};

export const useIdentifierForm = () => {
  const t = useT();
  const [secondaryCriteriaList, setSecondaryCriteriaList] = useState<SecondaryCriteria[]>([]);

  const schema = useMemo(
    () =>
      object({
        identifier: record(any(), {
          message: t("page.rules.modal.create.form.type.element.error.required"),
        }),
      }),
    [t]
  );

  const methods = useForm<IdentifierFormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      identifier: null,
    },
  });

  return {
    control: methods.control,
    secondaryCriteriaList,
    setSecondaryCriteriaList,
    submit: methods.handleSubmit,
    reset: methods.reset,
    hasError: methods.formState.isSubmitted
      ? Object.keys(methods.formState.errors).length > 0
      : false,
    methods,
  };
};
